// Import UIkit
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";

var custom = (function($, window, document, Drupal, once) {
  // Autocomplete search.
  //
  Drupal.behaviors.autocomplete_search = {
    attach: function(context, settings) {
      $(once("autocomplete_search", "input.autocomplete-search", context)).each(
        function() {
          let cache = {};
          $("input.autocomplete-search").autocomplete({
            source: function(request, response) {
              let term = request.term;

              if (term in cache) {
                response(cache[term]);
                return;
              }
              $.get("/api/search?query=" + term, function(data) {
                if (data.length > 0) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].cat.length > 0) {
                      data[i].value =
                        Drupal.decodeEntities(data[i].title) +
                        " - " +
                        data[i].cat;
                    } else {
                      data[i].value = Drupal.decodeEntities(data[i].title);
                    }
                  }
                  cache[term] = data;
                  response(data);
                }
              });
            },
            minLength: 3,
            open: function(event, ui) {
              // Select the last word of the search items
              $(".ui-menu-item > .ui-menu-item-wrapper").html(function() {
                let text = $(this)
                  .text()
                  .split(" ");
                let last = text.pop();
                return (
                  text.join(" ") +
                  (text.length > 0
                    ? ' <span class="ui-menu-item--type">' + last + "</span>"
                    : last)
                );
              });
            },
            select: function(event, ui) {
              setTimeout(function() {
                Drupal.searchGoto(ui.item.url);
              }, 1000);
            }
          });
        }
      );
    }
  };

  Drupal.searchSubmitted = false;

  Drupal.searchGoto = function(url) {
    if (!Drupal.searchSubmitted) {
      Drupal.searchSubmitted = true;
      window.location.href = url;
    }
  };

  // Decode HTML entities.
  //
  Drupal.decodeEntities = function(encodedString) {
    let textArea = document.createElement("textarea");
    textArea.innerHTML = encodedString;
    return textArea.value;
  };

  Drupal.behaviors.openSearch = {
    attach: function(context, settings) {
      let searchBtn = $(".user-search");
      let searchInput = $("#block-autocomplete-search-block");
      let autocompleteForm = $("#autocomplete-search-form");

      $(once("open-search", searchBtn)).click(function() {
        searchInput.toggleClass("open");
      });

      autocompleteForm.after(
        '<span id="closeSearch" class="close"><i class="far fa-times"></i></span>'
      );
    }
  };

  Drupal.behaviors.closeSearch = {
    attach: function(context, settings) {
      let searchInput = $("#block-autocomplete-search-block");
      let searchCloseBtn = $("#closeSearch");

      $(once("close-search", searchCloseBtn)).click(function() {
        searchInput.removeClass("open");
      });
    }
  };

  Drupal.behaviors.autocompleteSearch = {
    attach: function(context, settings) {
      $(window).on("load resize", function() {
        $("input.autocomplete-search").bind("autocompleteopen", function(
          event,
          ui
        ) {
          let autocompleteWidth = $(this).width();
          $(".ui-autocomplete.ui-menu").width(autocompleteWidth + 20);
        });
      });
    }
  };

  // Mobile: Menu Open.
  //
  Drupal.behaviors.mobileMenuOpen = {
    attach: function(context, settings) {
      let bodyEl = $("body");
      let mobileBtnOpen = $(".mobile-nav--btn");
      let mobileBtnClose = $(".mobile-nav--close");
      let mobileNav = $(".mobile-nav");

      // Open mobile menu
      mobileBtnOpen.click(function(e) {
        mobileNav.addClass("mobile-nav--open");
        bodyEl.addClass("no-scroll");
      });

      // Close mobile menu
      mobileBtnClose.click(function(e) {
        mobileNav.removeClass("mobile-nav--open");
        bodyEl.removeClass("no-scroll");
      });
    }
  };

  // Mobile: Menu Levels.
  //
  Drupal.behaviors.mobileMenuLevels = {
    attach: function(context, settings) {
      let mobileMenu = $("#block-petfinder-mobile-menu");
      let mobileMenuHeader = $(".mobile-nav__header");
      let mobileMenuTitle = $("h2.mobile-nav--title");
      let mainUl = $("#block-petfinder-mobile-menu > ul.menu");
      let arrowBack = $(".mobile-nav--back");
      let level = 0;

      // Add the level to every menu
      mainUl.attr("level", level);
      $(">li", mainUl).each(function() {
        let currentLi = $(this);
        $("ul", currentLi).each(function() {
          level++;
          $(this).attr("level", level);
        });
        level++;
      });

      // Show next level after menu click
      $("a, span", mobileMenu).click(function(e) {
        let title = $(this).html();
        let currentLevel = $(this)
          .parents("ul")
          .attr("level");
        let nextLevel = $("> ul", $(this).parent()).attr("level");
        addActiveHeaderTitle(title, mobileMenuTitle, currentLevel);

        if (nextLevel && nextLevel !== "undefined") {
          e.preventDefault();
          showNextLevel(nextLevel);

          if (nextLevel && nextLevel > 0) {
            arrowBack.addClass("mobile-nav--back-show");
          }
        }
      });

      // Arrow back
      $(arrowBack, mobileMenuHeader).click(function() {
        let header = mobileMenuHeader.find(mobileMenuTitle);
        level = parseInt(header.attr("level"));
        let title = $("ul[level=" + level + "]")
          .parent("li")
          .find("span, a")
          .html();
        showNextLevel(level);

        if (level > 0) {
          level = 0;
          addActiveHeaderTitle(title, header, level);
        } else {
          header.html("");
          arrowBack.removeClass("mobile-nav--back-show");
        }
      });

      // Add title to the header of the menu
      function addActiveHeaderTitle(title, header, level) {
        header.html(title);
        header.attr("level", level);
      }

      // Go to the next level
      function showNextLevel(nextLevel) {
        nextLevel = parseInt(nextLevel);

        $("li", mainUl).hide();
        $(
          ">a, >span",
          $("ul[level=" + nextLevel + "] > li").parents("li")
        ).hide();
        $("ul[level=" + nextLevel + "]").show();
        $("ul[level=" + nextLevel + "] > li")
          .parents("li")
          .show();
        $("ul[level=" + nextLevel + "] > li").show();
        $("ul[level=" + nextLevel + "] > li a").show();
        $("ul[level=" + nextLevel + "] > li span").show();
      }
    }
  };

  // Flyout: Main Menu.
  //
  Drupal.behaviors.flyoutHeader = {
    attach: function(context, settings) {
      let menuLinks = $("#block-petfinder-main-menu > .menu > .menu-item > *");
      let menuElementFirst = $(".menu--search");
      let menuElementSecond = $(".menu--guide");
      let menuElementThird = $(".menu--catalog");
      let menuElementFourth = $(".menu--support");
      let flyoutRegionFirst = $("#flyout-nav--search");
      let flyoutRegionSecond = $("#flyout-nav--guide");
      let flyoutRegionThird = $("#flyout-nav--catalog");
      let flyoutRegionFourth = $("#flyout-nav--support");

      let windowsWidth = $(window).outerWidth();
      if (windowsWidth >= 860) {
        showFlyoutOnClick(menuElementFirst, flyoutRegionFirst);
        showFlyoutOnClick(menuElementSecond, flyoutRegionSecond);
        showFlyoutOnClick(menuElementThird, flyoutRegionThird);
        showFlyoutOnClick(menuElementFourth, flyoutRegionFourth);
      }

      function showFlyoutOnClick(menuElement, flyoutRegion) {
        $(once("showFlyoutOnClick", menuElement)).on("click", function(e) {
          e.preventDefault();
          flyoutRegion.toggleClass("open-flyout-menu");
          menuElement.toggleClass("menu--active");

          menuLinks.not(this).removeClass("menu--active");
          $(".flyout-nav__wrapper")
            .not(flyoutRegion)
            .removeClass("open-flyout-menu");
        });
      }
    }
  };

  // PG 2 Image: Add Lightbox.
  //
  Drupal.behaviors.imageLightbox = {
    attach: function(context, settings) {
      var paragraphImage = $(".paragraph--type--image");

      $(once("imageLightbox", paragraphImage, context)).each(function() {
        var paragraph = $(this);
        var image = paragraph.find("img.media__image");
        var imageUrl = image.attr("data-src");
        var imageCaption = image.attr("alt");

        image.wrap(
          '<div uk-lightbox><a href="' +
            imageUrl +
            '" data-caption="' +
            imageCaption +
            '"></a></div>'
        );
      });
    }
  };

  // PG 7: Accordion.
  //
  Drupal.behaviors.accordion = {
    attach: function(context, settings) {
      var paragraphAccordion = $(".paragraph--type--accordion");

      $(once("accordion", paragraphAccordion, context)).each(function() {
        var paragraph = $(this);
        var accordionTitle = paragraph.find(".pg-accordion__title");
        var accordionContent = paragraph.find(".pg-accordion__content");

        accordionTitle.click(function() {
          accordionContent.slideToggle("fast");
          paragraph.toggleClass("pg-accordion--open");
        });
      });
    }
  };

  // Slider Image Counter.
  //
  Drupal.behaviors.imageCounter = {
    attach: function(context, settings) {
      // Get images.
      var images = $(".slider-item-counter");

      // Set starting index.
      var index = images.attr("img-index");
      $("#counter").text(index + "/" + images.length);

      $(".uk-position-center-right").on("click", function() {
        var currentImg = $(".uk-active");
        var nextImg = currentImg.next();

        if (nextImg.length) {
          // Find the index of the image.
          var index = images.index(nextImg);
          $("#counter").text(index + 1 + "/" + images.length);
        }
      });

      $(".uk-position-center-left").on("click", function() {
        var currentImg = $(".uk-active");
        var prevImg = currentImg.prev();

        if (prevImg.length) {
          // Find the index of the image.
          var index = images.index(prevImg);
          $("#counter").text(index + 1 + "/" + images.length);
        }
      });
    }
  };

  // Profile checkbox.
  //
  Drupal.behaviors.profileCheckbox = {
    attach: function(context, settings) {
      var checked_val = "_none";
      let radioInput = $(
        'input[name="field_profile"][value="shelter"], input[name="field_profile"][value="breeder"]'
      );
      radioInput.on("click", function() {
        if ($(this).val() == checked_val) {
          $("input[name=field_profile][value=_none]").click();
          checked_val = "_none";
        } else {
          checked_val = $(this).val();
        }
      });
    }
  };

  // Pet ad type checkbox.
  //
  Drupal.behaviors.petAdTypeCheckbox = {
    attach: function(context, settings) {
      var checked_val = "_none";
      let radioInput = $('input[name="field_pet_ad_type"][value="113"]');
      radioInput.on("click", function() {
        if ($(this).val() == checked_val) {
          $("input[name=field_pet_ad_type][value=_none]").click();
          checked_val = "_none";
        } else {
          checked_val = $(this).val();
        }
      });
    }
  };

  // Profile checkbox.
  //
  Drupal.behaviors.pethideCheckboxes = {
    attach: function(context, settings) {
      if ($(".node-pet-ad-form").length >= 1) {
        return;
      }

      let radioInput = $(
        'input[name="field_pet_species"][value="783"],input[name="field_pet_species"][value="784"],input[name="field_pet_species"][value="786"],input[name="field_pet_species"][value="789"]'
      );

      $('input[name="field_pet_species"]')
        .parent()
        .hide();
      radioInput.parent().show();
    }
  };

  // Guide filter.
  //
  Drupal.behaviors.guideFilter = {
    attach: function(context, settings) {
      $(once("guideFilter", ".form-item-term-node-tid-depth > label")).on(
        "click",
        function() {
          $(this).toggleClass("open");
          $(".form-item-term-node-tid-depth > .bef-links").toggleClass("open");
        }
      );

      $(
        once(
          "guideFilter",
          ".form-item-field-register-canton-target-id > label"
        )
      ).on("click", function() {
        $(this).toggleClass("open");
        $(
          ".form-item-field-register-canton-target-id > .bef-links"
        ).toggleClass("open");
      });

      $(
        once(
          "guideFilter",
          ".form-item-field-register-dogschool-offer-target-id > label"
        )
      ).on("click", function() {
        $(this).toggleClass("open");
        $(
          ".form-item-field-register-dogschool-offer-target-id > .bef-links"
        ).toggleClass("open");
      });
    }
  };

  // Sort filters.
  //
  Drupal.behaviors.userViewsFilter = {
    attach: function(context, settings) {
      $(once("userViewsFilter", ".view-user-ads fieldset legend")).on(
        "click",
        function() {
          $(this).toggleClass("open");
          $(".view-user-ads fieldset .fieldset-wrapper").toggleClass("open");
        }
      );
    }
  };

  // Form Tooltip.
  //
  Drupal.behaviors.formTooltip = {
    attach: function(context, settings) {
      let formItem = $(".form-item");

      $(once("form-tooltip", formItem, context)).each(function() {
        var description = $(this);
        var descriptionBtn = description.find(".description-btn");
        var descriptionContent = description.find(".description");
        let descriptionClose = description.find(".description-close");

        descriptionBtn.click(function() {
          descriptionContent.addClass("open");
        });

        descriptionClose.click(function() {
          descriptionContent.removeClass("open");
        });
      });
    }
  };

  Drupal.behaviors.advancedSearch = {
    attach: function(context, settings) {
      // Get the modal
      let modal = $("#advanced-search-modal");

      let btn = $("#advanced-search-button");

      let span = $("#closeModal");

      let apply = $("#applyModal");

      btn.click(function() {
        modal.css("display", "block");
        $("body").addClass("no-scroll");
      });

      span.click(function() {
        modal.css("display", "none");
        $("body").removeClass("no-scroll");
      });

      apply.click(function() {
        modal.css("display", "none");
        $("body").removeClass("no-scroll");
      });

      window.onclick = function(event) {
        if (event.currentTarget === modal) {
          modal.css("display", "none");
          $("body").removeClass("no-scroll");
        }
      };
    }
  };

  Drupal.behaviors.searchSubscribe = {
    attach: function(context, settings) {
      // Get the modal
      let modalFilter = $("#advanced-search-modal");
      let modal = $("#block-suchespeichern");
      let btn = $("#search-subscribe-button");
      let span = $("#closeModalAbo");

      btn.click(function() {
        modal.css("display", "flex");
        $("body").addClass("no-scroll");
      });

      span.click(function() {
        modal.css("display", "none");
        modalFilter.css("display", "none");
        $("body").removeClass("no-scroll");
      });
    }
  };

  // Filter Dropdown.
  //
  Drupal.behaviors.filterDropdowns = {
    attach: function(context, settings) {
      var block = $(
        ".block-facet-blockcountry-origin, .block-facet-blockalter, .block-facet-blockrasse, .block-facet-blockgeschlecht, .block-facet-blockgroesse, .block-facet-blockfellart, .block-facet-blocktierart, .block-facet-blocktierart-nager-, .block-facet-blockattitude"
      );

      $(once("filterDropdowns", block, context)).each(function() {
        var dropdown = $(this);
        var dropdownTitle = dropdown.find("h2");

        if (dropdownTitle.closest(block).hasClass("facet-active")) {
          $(this)
            .closest(block)
            .addClass("open-dropdown");
          dropdownTitle.addClass("open-dropdown-title");
        }

        dropdownTitle.click(function() {
          $(this).toggleClass("open-dropdown-title");
          $(this)
            .closest(block)
            .toggleClass("open-dropdown");
        });
      });
    }
  };

  // Tooltip.
  //
  Drupal.behaviors.tooltip = {
    attach: function(context, settings) {
      $("#search-subscribe-button-login").mouseenter(function() {
        $(".pg-pet-ad-category .tooltip").addClass("display-tooltip");
      });

      $("#search-subscribe-button-login").mouseleave(function() {
        $(".pg-pet-ad-category .tooltip").removeClass("display-tooltip");
      });

      $("#block-quicklinkmenu").mouseenter(function() {
        $("#block-quicklinkmenu .tooltip").addClass("display-tooltip");
      });

      $("#block-quicklinkmenu").mouseleave(function() {
        $("#block-quicklinkmenu .tooltip").removeClass("display-tooltip");
      });

      $("#block-quicklinkmenu-mobile").mouseenter(function() {
        $("#block-quicklinkmenu-mobile .tooltip").addClass("display-tooltip");
      });

      $("#block-quicklinkmenu-mobile").mouseleave(function() {
        $("#block-quicklinkmenu-mobile .tooltip").removeClass(
          "display-tooltip"
        );
      });
    }
  };

  // PG 7: Accordion.
  //
  Drupal.behaviors.accordionRegister = {
    attach: function(context, settings) {
      var registerAccordion = $(".register-full__details");

      $(once("accordionRegister", registerAccordion, context)).each(function() {
        var accordion = $(this);
        var accordionTitle = accordion.find(".register-full__details-title");
        var accordionContent = accordion.find(
          ".register-full__details-content"
        );

        accordionTitle.click(function() {
          accordionContent.slideToggle("fast");
          accordion.toggleClass("register-full__details--open");
        });
      });
    }
  };

  // History Back Button
  //
  Drupal.behaviors.historyBackButton = {
    attach: function() {
      const backButton = $(".pet-ad-full__back a");
      const absoluteUrl = location.hostname;

      if (document.referrer.includes(absoluteUrl)) {
        // Remove the home url
        backButton.removeAttr("href");

        // Load the previous URL in the history list
        backButton.on("click", function() {
          window.history.back();
        });
      }
    }
  };

  // Open links menu
  //
  Drupal.behaviors.openLinksMenu = {
    attach: function() {
      const menus = $(".field--name-field-guide-category-menu");

      menus.each(function() {
        const menu = $(this);
        const title = menu.find(".menu-title");

        title.click(function() {
          menu.toggleClass("is-open");
        });

        $(document).click(function(e) {
          e.stopPropagation();

          // check if the clicked area is dropDown or not
          if (menu.has(e.target).length === 0) {
            menu.removeClass("is-open");
          }
        });
      });
    }
  };
})(jQuery, window, document, Drupal, once);

export default custom;
